/* eslint-disable react-refresh/only-export-components */
import { useDrag } from "react-dnd";
import { X } from "lucide-react";

interface DraggableTabProps {
  tabId: string;
  tabLabel: string;
  isActive: boolean;
  paneId: string;
  onClick: () => void;
  onClose: (e: React.MouseEvent) => void;
}

export const ItemTypes = {
  TAB: "tab",
};

export function DraggableTab({
  tabId,
  tabLabel,
  isActive,
  paneId,
  onClick,
  onClose,
}: DraggableTabProps) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.TAB,
    item: { tabId, paneId },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag as unknown as React.Ref<HTMLDivElement>}
      role="button"
      tabIndex={0}
      data-testid={`mbc-tab-${tabId}`}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      className={`flex items-center gap-2 px-4 py-3 cursor-pointer border-b-2 transition-colors ${
        isActive ? "border-b-2" : "border-transparent"
      }`}
      style={{
        borderBottomColor: isActive ? "#5A8DAB" : "transparent",
        backgroundColor: isActive ? "#F5F7FA" : "white",
        opacity: isDragging ? 0.5 : 1,
        cursor: isDragging ? "grabbing" : "grab",
      }}
      onClick={onClick}
    >
      <span
        className="text-sm font-medium"
        style={{ color: isActive ? "#1A202C" : "#475569" }}
      >
        {tabLabel}
      </span>
      <button
        onClick={onClose}
        data-testid={`mbc-tab-close-${tabId}`}
        className="hover:bg-slate-200 rounded p-0.5"
      >
        <X size={14} style={{ color: "#475569" }} />
      </button>
    </div>
  );
}
